import { Injectable } from "@angular/core";
import { ClaimStatusFilter } from "../models/filter/ClaimFilter.model";

@Injectable({ providedIn: 'root' })
export class ClaimFilterStateService {

    statusFilter: ClaimStatusFilter = this.getDefaultStatusFilter();
    submittedDate: string = '';
    arrivalDate: string = '';
    departureDate: string = '';

    reset(): void {
        this.resetStatusFilter();
        this.resetSubmittedDateFilter();
        this.resetArrivalDateFilter();
        this.resetDepartureDateFilter();
    }

    resetStatusFilter(): void {
        this.statusFilter = this.getDefaultStatusFilter();
    }

    resetSubmittedDateFilter(): void {
        this.submittedDate = '';
    }

    resetArrivalDateFilter(): void {
        this.arrivalDate = '';
    }

    resetDepartureDateFilter(): void {
        this.departureDate = '';
    }

    isStatusFilterActive(): boolean {
        return !this.statusFilter.completed 
            || !this.statusFilter.draft
            || !this.statusFilter.submitted;
    }

    allStatusFiltersDisabled(): boolean {
        return !this.statusFilter.completed 
            && !this.statusFilter.draft
            && !this.statusFilter.submitted;
    }

    allStatusFiltersEnabled(): boolean {
        return this.statusFilter.completed 
            && this.statusFilter.draft
            && this.statusFilter.submitted;
    }

    private getDefaultStatusFilter(): ClaimStatusFilter {
        return { 
            draft: true, 
            submitted: true, 
            completed: true 
        }
    }

    isCompletedStatusFilterActive(): boolean {
        return this.statusFilter.completed;
    }

    isDraftStatusFilterActive(): boolean {
        return this.statusFilter.draft;
    }

    isSubmittedStatusFilterActive(): boolean {
        return this.statusFilter.submitted;
    }
}